//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { shareFun } from '@/util/const'
import { VIDEO_SRC, SHARE_INFO } from './stories'

export default {
  name: 'storyDetail',
  data () {
    return {
      src: '',
      title: '',
      cover: '',
      content: ''
    }
  },
  created () {
    const { id } = this.$route.params
    const target = VIDEO_SRC.find(item => item.key === id)
    this.src = target.src
    this.cover = target.cover
    this.title = SHARE_INFO.title
    this.content = SHARE_INFO.content

    shareFun({
      type: 1,
      title: this.title,
      content: this.content,
      url: window.location.href,
      img: `https://mylink.oss-accelerate.aliyuncs.com/mylinkH5/shareLogo/shareLogo`
    })
  }
}



// WEBPACK FOOTER //
// ./src/page/5gRewritesStory/detail.vue